import type { Auth0UserLike, RegionalUserLike } from '../../types/auth0-user.type'

import { getProfileValue } from './getProfileValue'
import { normalizeValue } from './normalizeValue'

export const getEmail = (auth0User: Auth0UserLike, regionalData?: RegionalUserLike | null): string =>
  normalizeValue(regionalData?.userEmail) || getProfileValue(auth0User.profile?.email, auth0User.email)
